import axios from "axios";

export const logginIn = async({
    username,
    password,
    setError,
    setLoader,
    setPassword,
    user,
    global,
    login = true
}) => {
    setError(null)
    setLoader(true)
    let url = global.domain+`v3-api/v3/login.json`;
    let res = await axios.post(url, {
        username: username ? username.trim() : '',
        password
    }).catch(function (error) {
        let msg = error?.response?.data?.message || error?.message || 'Error con el usuario y contraseña';
        if (msg.includes('Internal Error') || msg.includes('500') || error?.response?.status === 500) {
            msg = 'Ocurrió un error en el servidor al procesar el inicio de sesión. Por favor intenta más tarde o contacta a soporte.';
        }
        setError(msg)
        console.error(error.message)
        setLoader(false)
        return null;
    });

    if(!res || !res.data){
        if (res !== null) {
            setPassword('')
            setError('Error con el usuario y contraseña')
            setLoader(false)
        }
        return;
    }

    var metadata = {
        user: res.data
    }
    
    localStorage.setItem('user', JSON.stringify(res.data));
    const token = (res?.data?.franchise?.paymentMethods ?? []).find(payment => payment.actionname === 'quentli')?._matchingData?.FranchisePaymentmethods?.value ?? undefined;
    localStorage.setItem('QuentliToken', token);
    user.setUser(res.data);

    setLoader(false)
}